export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-2-3b6f64c975c21b4a0b366290883ad086.jpg";